import React from 'react';
import AvtarBadge from './dashboard/AvtarBadge';
// import LoomVideoRecorder from './candidate-assessment-flow/LoomVideoRecorder';

export default function CompoentView() {
    return (
        <></>
    );
}
